// extracted by mini-css-extract-plugin
module.exports = {"title":"CardFrame_title__pNwVs","subtitle":"CardFrame_subtitle__rRe_9","description":"CardFrame_description__6xKUU","frame":"CardFrame_frame__8izCD"};